<template>
  <div class="guidanceCon">
    <div>
      <lk-card >
        <div class="guidanceContainer">
          <h3>购药信息</h3>
          <PatientInfos
          :salePrescription='salePrescription'
          />
          <lk-table
            :columns='columns1'
            border
            :data='saleOrderDetail'
            style="marginBottom: 10px"
          ></lk-table>
          <lk-table
            :columns='columns2'
            border
            :data='saleOrderDetail'
          ></lk-table>
        </div>
        <div class="appointment">
          <div class="container">
            <div class="appointmentCon">
              <h3>随访预约</h3>
              <div class="introduce">
                <span class="introduceTxt">
                  温馨提示：请在预约随访时间之前告知患者，电话随访有助力患者更好的遵从医嘱进行治疗。药房将通过电话的方式按照与患者约定的方式联系患者。
                </span>
                <lk-form :label-width='85' label-position="right">
                  <Interviewee
                    ref="Interviewee"
                    v-model="task"
                    :taskIds='taskIds'
                    :isEdit="isEdit"
                  ></Interviewee>
                </lk-form>
              </div>
            </div>
            <lk-divider class="divider" />
            <div>
              <span>随访和购药记录</span>
              <lk-table
                :columns='columns3'
                border
                :data='interviewVoList'
                style="marginBottom: 10px"
              ></lk-table>
              <lk-table
                :columns='columns4'
                border
                :data='historyPurchaseDetails'
              ></lk-table>
            </div>
          </div>
        </div>
        <div class="confirmOrder">
          <div>
            <lk-checkbox v-model="check" @on-change="handlerChecked">
              <span>订单信息确认无误,确认发药</span>
            </lk-checkbox>
          </div>
          <div class="dispenser">
            <div style="width: 70px">发药人:</div>
            <lk-input :disabled='true' v-model="salePrescription.auditPharmacistName"></lk-input>
          </div>
        </div>
      </lk-card>
    </div>
  </div>
</template>
<script>
import PatientInfos from '../../components/sale/PatientInfos.vue';
import Interviewee from '../../components/sale/Interviewee.vue';
import Uploader from '../../components/Uploader.vue';
import utils from '../../libs/utils';

export default {
  name: 'GuidanceAndAppointment',
  components: {
    PatientInfos,
    Interviewee,
  },
  props: {
    salePrescription: {
      type: Object,
    },
    interviewTask: {
      type: Object,
    },
    saleOrderDetail: {
      type: Array,
    },
    historyPurchaseDetails: {
      type: Array,
    },
    taskIds: {
      type: Array,
    },
    interviewVoList: {
      type: Array,
    },
    isEdit: {
      type: Boolean,
    },
    checked: {
      type: Boolean,
    },
  },
  model: {
    prop: 'interviewTask',
    event: 'change',
  },
  computed: {

  },
  watch: {
    interviewTask: {
      handler() {
        this.task = this.interviewTask;
      },
      deep: true,
    },
    checked: {
      handler() {
        this.check = this.checked;
      },
      deep: true,
    },
  },
  data() {
    return {
      check: false,
      task: {},
      stopList: [
        {
          id: 1,
          name: '1111',
        },
        {
          id: 2,
          name: '2222',
        },
        {
          id: 3,
          name: '3333',
        },
      ],
      contactRelationList: {
        1: '本人',
        2: '父母',
        3: '子女',
        4: '朋友',
        5: '其他',
      },
      columns1: [
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '通用名',
          key: 'approvedDrugNames',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
        },
        {
          title: '数量',
          key: 'goodsCount',
          minWidth: 116,
        },
        {
          title: '处方医院',
          key: 'hospital',
          minWidth: 116,
        },
        {
          title: '处方医生',
          key: 'doctor',
          minWidth: 116,
        },
        {
          title: '诊断',
          key: 'diseaseName',
          minWidth: 116,
        },
        {
          title: '诊断说明',
          key: 'diseaseRemark',
          minWidth: 116,
        },
        {
          title: '用法',
          key: 'goodsUsage',
          minWidth: 116,
        },
        {
          title: '频次',
          key: 'frequencyName',
          minWidth: 116,
        },
        {
          title: '每次用量',
          key: 'dosage',
          minWidth: 116,
        },
        {
          title: '有效期',
          key: 'expireDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.expireDate)),
        },
        {
          title: '储存条件',
          key: 'conditionName',
          minWidth: 116,
        },
        {
          title: '生产厂家',
          key: 'producer',
          minWidth: 116,
        },
      ],
      columns2: [
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 30,
        },
        {
          title: '使用注意事项',
          key: 'goodsUsageAttention',
          render: (h, { row }) => h('span', {
            domProps: {
              innerHTML: `${row.goodsUsageAttention.replace(/(\r\n|\n|\r)/gm, '<br />')}`,
            },
          }),
          minWidth: 400,
        },
        {
          title: '护理方案',
          key: 'goodsUsageNursing',
          render: (h, { row }) => h('span', {
            domProps: {
              innerHTML: `${row.goodsUsageNursing.replace(/(\r\n|\n|\r)/gm, '<br />')}`,
            },
          }),
          minWidth: 400,
        },
        {
          title: '金融服务方案',
          key: 'goodsUsageFinance',
          render: (h, { row }) => h('span', {
            domProps: {
              innerHTML: `${row.goodsUsageFinance.replace(/(\r\n|\n|\r)/gm, '<br />')}`,
            },
          }),
          minWidth: 400,
        },
        {
          title: '药学服务卡',
          key: 'cardUrl',
          minWidth: 50,
          render: (h, params) => h('div', [
            h(Uploader, {
              props: {
                url: params.row.cardUrl,
                able: false,
              },
            }),
          ]),
        },
      ],
      columns4: [
        {
          title: '购药日期',
          key: 'purchaseDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.formatTime(params.row.purchaseDate)),
        },
        {
          title: '订单编号',
          key: 'orderNo',
          minWidth: 116,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
        },
        {
          title: '通用名',
          key: 'approveName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 116,
        },
        {
          title: '数量',
          key: 'num',
          minWidth: 116,
        },
        {
          title: '有效期',
          key: 'expiryDate',
          minWidth: 116,
          render: (h, params) => h('span', utils.formatTime(params.row.expiryDate)),
        },
        {
          title: '储存条件',
          key: 'storageCondition',
          minWidth: 116,
        },

        {
          title: '用法',
          key: 'goodsUsage',
          minWidth: 116,
        },
        {
          title: '频次',
          key: 'frequencyName',
          minWidth: 116,
        },
        {
          title: '每次用量',
          key: 'goodsDosage',
          minWidth: 116,
        },
      ],
      columns3: [
        {
          title: '随访任务',
          key: 'id',
          minWidth: 116,
        },
        {
          title: '呼叫编号',
          key: 'callNumber',
          minWidth: 116,
        },
        {
          title: '预约时间',
          key: 'times',
          minWidth: 116,
        },
        {
          title: '随访时间',
          key: 'followUpTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.formatTime(params.row.followUpTime)),
        },
        {
          title: '随访结果',
          key: 'results',
          minWidth: 116,
          render: (h, params) => h('span', params.row.results === 1 ? '本次随访成功' : '本次随访失败'),
        },
      ],
    };
  },
  methods: {
    handlerChecked(val) {
      this.$emit('update:checked', val);
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs.Interviewee.validaForm().then((valid) => {
          this.$emit('change', this.task);
          resolve(valid);
        });
      });
    },
    created() {
    },
    mounted() {
    },
  },
};
</script>
<style lang="less" scoped>
.checkBtn {
  margin: 8px 0;
}
.introduce {
  padding-left: 30px;
}
/deep/ .fileHolder {
  height: 100%;
}
.reasonStop {
  display: flex;
  /deep/ .ivu-select{
    width: 200px;
  }
}
.confirmOrder {
  width: 100%;
  height: 50px;
  display: flex;
  line-height: 50px;
  margin-top: 20px;
  vertical-align: middle;
  background-color: #fff;
  .dispenser {
    margin-left: 50px;
    display: flex;
    align-items: center;
  }
}
.appointment {
  .introduce {
    .introduceTxt {
      display: inline-block;
      padding: 8px 0 8px 26px;
    }
    .txt {
      display: inline-block;
      color: red;
      padding: 8px 2px 0 0;
    }
  }
  .reasonStop {
    display: flex;
    /deep/ .ivu-select{
      width: 200px;
    }
  }
}
.guidanceCon {
  // height: 100%;
  position: relative;
  .bottomFix{
    background: #fff;
    position: relative;
    padding: 0 38px;
    bottom:0;
    left: 0;
    width: 100%;
    border-top: 1px solid #eee;
    height: 60px;
    z-index: 10;
    box-shadow: 0 0 8px #eee;
    .btns{
      float: right;
      height: 60px;
      line-height: 60px
    }
  }
}
</style>
